import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { JsonEditorView } from './defaultviews';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';

export class ReactFormJson extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let ViewToUse = JsonEditorView; //Use demo view by default
        
        if(this.props.viewProvider.getJsonEditorView)
            ViewToUse = this.props.viewProvider.getJsonEditorView();
        
        return <ReactFormGroupWrapper {...this.props}>
            <ViewToUse  {...this.props}/>
        </ReactFormGroupWrapper>;
    }
}

ReactFormJson.propTypes = {
    name: PT.string,
    value: PT.string,
    label: PT.string,
    onChange: PT.func,
    height: PT.string,
    viewProvider: PT.object,
    lang: PT.string,
    readOnly: PT.bool
};

ReactFormJson.defaultProps = {
    readOnly: false,
};
